import type { AxiosRequestConfig } from 'axios'
import { decamelizeKeys } from 'humps'

type WithAttachments = { attachments?: unknown }

/**
 * 添付ファイルを含む更新リクエストの body / config を組み立てる。
 *
 * `attachments` 配列の内部キーは BE が camelCase（name / size / lastModified / content）を
 * 期待する（PC 版は RestClient で decamelize せず camelCase のまま送っており、それが BE 契約）。
 * SP の自動 decamelize で `last_modified` に変換すると未知フィールド扱いで保存に失敗するため、
 * `attachments` を退避し残りだけ snake_case 化したうえで interceptor の自動 decamelize を
 * スキップする（`skipDataDecamelize`）。
 *
 * `attachments` を含まない場合は params をそのまま渡し、通常の decamelize に任せる。
 */
export const buildAttachmentAwareRequest = <T extends WithAttachments>(
  params: T
): { body: unknown; config?: AxiosRequestConfig } => {
  if (!params.attachments) {
    return { body: params }
  }
  const { attachments, ...rest } = params
  return {
    body: { ...decamelizeKeys(rest as Record<string, unknown>), attachments },
    config: { skipDataDecamelize: true } as unknown as AxiosRequestConfig,
  }
}
